import { Helmet } from "react-helmet-async";
import Statistics from "./Statistics";

const Default = () => (
  <>
    <Helmet title="Datajolt | Home" />
    <Statistics />
  </>
);

export default Default;
